import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import fileService from '../../services/fileService';

interface FileUploadState {
  isLoading: boolean;
  error: string | null;
  uploadedFile: string | null;
}

const initialState: FileUploadState = {
  isLoading: false,
  error: null,
  uploadedFile: null,
};

export const uploadFile = createAsyncThunk(
  'fileUpload/uploadFile',
  async (file: File, { rejectWithValue }) => {
    try {
      const fileUrl = await fileService.uploadFile(file);
      return fileUrl;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to upload file'
      );
    }
  }
);

const fileUploadSlice = createSlice({
  name: 'fileUpload',
  initialState,
  reducers: {
    resetFileUpload: (state) => {
      state.isLoading = false;
      state.error = null;
      state.uploadedFile = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(uploadFile.fulfilled, (state, action: PayloadAction<string>) => {
        state.isLoading = false;
        state.uploadedFile = action.payload;
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetFileUpload } = fileUploadSlice.actions;
export default fileUploadSlice.reducer;